import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=2c7ef8f5&scoped=true"
import script from "./Tab.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tab.vue?vue&type=style&index=0&id=2c7ef8f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ef8f5",
  null
  
)

export default component.exports